/* ============================================================================
   FOODIE SONA — CENTRAL CONTENT CONFIGURATION  (single source of truth)
   ============================================================================ */

export const CREATOR = {
  name: "Sona",
  brand: "Foodie Sona",
  base: "Puri, Odisha, India",
  tagline: "Stories through Food and Travel.",
};

export const LINKS = {
  whatsapp: "https://wa.me/918917632525",
  email: "mailto:foodiesona13@gmail.com",
  instagram: "https://www.instagram.com/foodie_sona13",
  youtube: "https://youtube.com/@foodiesona13",
  instagramHandle: "@foodie_sona13",
  youtubeHandle: "@foodie_sona13",
  emailPlain: "foodiesona13@gmail.com",
};

export const whatsappWith = (text) =>
  `${LINKS.whatsapp}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Work", id: "work" },
  { label: "Services", id: "services" },
  { label: "Brands", id: "brands" },
  { label: "Contact", id: "contact" },
];

export const STATS = [
  { value: "24.8K+", label: "Followers", note: "Instagram" },
  { value: "2.4M+", label: "Instagram Views", note: "Last 30 Days" },
  { value: "1.12M+", label: "Accounts Reached", note: "Last 30 Days" },
  { value: "125K+", label: "Interactions", note: "Last 30 Days" },
  { value: "48K+", label: "Profile Visits", note: "Last 30 Days" },
];

export const HIGHLIGHT_STAT = {
  value: "88%",
  label: "Non-Follower Views",
  note: "A highly discoverable audience with strong reach beyond existing followers.",
};

export const SERVICES = [
  {
    index: "01",
    title: "Signature Reel",
    desc: "Professionally crafted Instagram Reels designed to showcase your brand authentically.",
    items: ["1 Instagram Reel", "Professional Editing", "Trending Audio", "Caption & Hashtags"],
  },
  {
    index: "02",
    title: "Brand Stories",
    desc: "Share your brand naturally through engaging Instagram Stories.",
    items: ["3–5 Instagram Stories", "Brand Mentions", "Swipe-up / Link Sticker where applicable", "Location & Tagging"],
  },
  {
    index: "03",
    title: "Brand Campaign",
    desc: "A complete collaboration combining multiple content formats for maximum visibility.",
    items: ["Reel + Stories", "Campaign Planning", "Cross Promotion", "Priority Delivery"],
  },
];

export const WHY = [
  { index: "01", title: "Authentic Storytelling", desc: "Content built around real experiences rather than traditional advertisements." },
  { index: "02", title: "Local Connection", desc: "Deep understanding of Puri, Odisha and the local food and lifestyle ecosystem." },
  { index: "03", title: "Discovery-Led Reach", desc: "88% of recent Instagram views came from non-followers, demonstrating strong discovery beyond the existing audience." },
  { index: "04", title: "Creator-Led Content", desc: "Content designed specifically for social platforms, combining personality, experience and visual storytelling." },
];

export const BRANDS = [
  "Mishra Villa, Puri", "Sanjib Hero Showroom, Puri", "Naturals Salon, Puri", "Zkape Cafe",
  "Jai Jagannath — Odia Song", "Citrus Clothing, Puri", "Shree Khetra Rajo Rani Mohastav, Puri",
  "Zwitter Homes, Bhubaneswar", "Samriddhi Jewellery, Puri", "LAM Beauty Bar & Academy, Puri",
  "Party Basket, Bhubaneswar", "The Restro House Cafe, Puri", "OMM Maa Traders, Nimapada",
  "Baba Mani Luxury AC Bus", "Shree Jagannath Bastralaya, Nirakarpur", "Maa Mangala Catering",
  "Mahadev Jewellery, Kanas", "Jagannath Steel, Chandapura, Puri", "Grand Furniture",
  "Shree Ram Jasoda Enterprise, Puri", "Tech Zone, Puri", "Maa Dakshina Kali Decorates & Suppliers", "Salon Viva",
];

export const FEATURED_BRAND = "KFC India";

export const HERO_IMAGE = "hero";
export const ABOUT_IMAGE = "about";
export const CTA_IMAGE = "cta";

export const PILLARS = [
  { img: "pillar-food", title: "Food", desc: "Puri restaurant discoveries, local favourites, dishes and food experiences.", alt: "Sona exploring a food experience" },
  { img: "pillar-travel", title: "Travel", desc: "Destinations, stays, experiences and exploring Odisha and beyond.", alt: "Sona exploring a travel destination" },
  { img: "pillar-lifestyle", title: "Lifestyle", desc: "Fashion, everyday experiences, events and lifestyle discoveries.", alt: "Sona in a lifestyle setting" },
  { img: "pillar-brand", title: "Brand Stories", desc: "Authentic creator-led campaigns that introduce products, places and experiences to the audience.", alt: "Sona creating a brand experience" },
];

export const WORK_FILTERS = ["All", "Food", "Travel", "Lifestyle", "Brand Experiences"];
export const WORK = [
  { img: "work-1", category: "Food", span: "tall", alt: "Sona at a dining table with a plated meal, a food experience" },
  { img: "work-5", category: "Brand Experiences", span: "normal", alt: "Sona at a brand event standing in front of a partner backdrop" },
  { img: "work-6", category: "Lifestyle", span: "normal", alt: "Sona enjoying a drink, a lifestyle moment" },
  { img: "work-4", category: "Travel", span: "tall", alt: "Sona by the backwaters near a boat, exploring Odisha" },
  { img: "work-2", category: "Food", span: "normal", alt: "A plated dish photographed by Sona during a restaurant feature" },
  { img: "work-8", category: "Lifestyle", span: "tall", alt: "Sona at a cafe bar, a lifestyle discovery" },
  { img: "work-7", category: "Lifestyle", span: "medium", alt: "Sona standing at a modern restaurant, a lifestyle discovery" },
  { img: "work-9", category: "Brand Experiences", span: "tall", alt: "Sona in traditional attire at an event, a brand and lifestyle experience" },
  { img: "work-10", category: "Travel", span: "tall", alt: "Sona exploring a vibrant destination in a modern travel setting" },
];

export const INSTAGRAM_TILES = [
  { img: "ig-1", alt: "Sona in a floral outfit outdoors — travel content" },
  { img: "ig-2", alt: "Editorial cafe portrait of Sona — lifestyle content" },
  { img: "ig-3", alt: "Sona by the water near a boat — travel content" },
  { img: "ig-4", alt: "Sona enjoying grilled street food — food content" },
  { img: "ig-5", alt: "Sona with a signature drink — lifestyle content" },
  { img: "ig-6", alt: "Sona at a warmly lit cafe — lifestyle content" },
];

export const USED_IMAGES = [HERO_IMAGE, ABOUT_IMAGE, CTA_IMAGE, ...PILLARS.map((p) => p.img), ...WORK.map((w) => w.img), ...INSTAGRAM_TILES.map((t) => t.img)];

(function assertNoDuplicateImages() {
  const seen = new Set();
  const dups = [];
  USED_IMAGES.forEach((name) => { if (seen.has(name)) dups.push(name); seen.add(name); });
  if (dups.length && typeof console !== "undefined") console.warn("[siteData] Duplicate image asset(s) used more than once:", dups);
})();

export const COPY = {
  hero: {
    kicker: "Food • Travel • Lifestyle • Odisha", headlineTop: "Stories through", headlineBottom: "Food & Travel.",
    body: "Sona is a food, travel and lifestyle creator from Puri, Odisha, sharing restaurant discoveries, local experiences and stories that help people discover places, brands and experiences.",
    ctaPrimary: "Work With Sona", ctaSecondary: "Explore Her Work", scrollCue: "Scroll to explore", locationTag: "Puri, Odisha · India",
  },
  performance: {
    kicker: "01 — Performance at a Glance", headingLine1: "Real reach.", headingLine2: "Real discovery.",
    intro: "A highly discoverable audience with strong reach beyond existing followers. Current verified Instagram metrics.",
    highlightBody: "88% of recent Instagram views came from people who don’t yet follow Sona — content built to be discovered.",
  },
  about: {
    kicker: "02 — About", heading: "More than a food review. A story worth discovering.",
    body: "Based in Puri, Odisha, Sona creates food, travel and lifestyle content rooted in real experiences. From discovering Puri restaurants and local food to exploring destinations and sharing everyday experiences, her content brings places and brands closer to an audience that loves to explore.",
    badgeName: "Sona", badgeRole: "Creator & Storyteller", chips: ["Based in Puri, Odisha", "Instagram Creator", "Food • Travel • Lifestyle"],
  },
  work: { kicker: "03 — Selected Work", heading: "Selected Work", sub: "Real experiences. Real places. Stories created to be remembered." },
  pillars: { kicker: "04 — What Sona Creates", headingLead: "What Sona", headingEmphasis: "creates" },
  services: { kicker: "05 — Collaboration", heading: "How We Can Work Together", footnote: "Every collaboration is shaped around your brand — reach out to discuss what works best." },
  why: { kicker: "06 — Why Brands Work With Sona", headingLine1: "Content people discover.", headingLine2: "Experiences people remember." },
  brands: {
    kicker: "07 — Collaborations", heading: "Trusted by brands & businesses",
    sub: "From local businesses and restaurants to lifestyle brands and larger campaigns, Sona has created content across a growing range of categories.",
    featuredLabel: "Featured Collaboration", featuredCopy: "Among Sona’s collaborations is KFC India — a recognizable national brand. A reflection of content that travels well beyond a local audience.",
  },
  instagram: { kicker: "Latest on Instagram", followLabel: "Follow on Instagram", moreLabel: "See more on Instagram" },
  contact: {
    kicker: "08 — Let's Create", heading: "Have a story worth telling?", sub: "Let's create something people will want to watch, remember and share.",
    ctaWhatsapp: "Chat on WhatsApp", ctaEmail: "Email Sona", formNote: "Prefer to write? — WhatsApp is the fastest way to reach Sona", formSubmit: "Start the Conversation",
    formHint: "This opens WhatsApp with your details pre-filled — no account or sign-up needed.",
  },
  footer: { tagline: "Stories through Food and Travel.", copyright: "© 2026 Sona. All rights reserved.", metaLine: "Food • Travel • Lifestyle • Puri, Odisha" },
};
